module.exports = __webpack_public_path__ + "static/TeamCall_Comp-26181de2b900ea6c1a2a28131a9707ae.mp4";